export default {
  ticketDetail(state, { ticketDetail }) {
    state.ticketDetail = ticketDetail;
  },
  selectedShow(state, { selectedShow }) {
    state.selectedShow = selectedShow;
  },

  ticketTypeCount(state, { ticketTypeCount }) {
    state.ticketTypeCount = ticketTypeCount;
  },
  paymentData(state, { paymentData }) {
    state.paymentData = paymentData;
  },
  selectedSeats(state, { selectedSeats }) {
    state.selectedSeats = selectedSeats;
  },
  seats(state, seats) {
    state.seats = seats;
  },

  priceGroups(state, groups) {
    state.priceGroups = groups;
  },
  countdown(state, countdown) {
    state.countdown = countdown;
  },
  holdId(state, holdId) {
    state.holdId = holdId;
  },
  logID(state, logID) {
    state.logID = logID;
  },
  giftcard(state, { giftCardBalance, giftCardNumber, giftCardPin }) {
    state.giftCard = { giftCardBalance, giftCardNumber, giftCardPin };
  },
  redirectUrl(state, { RedirectUrl, Order }) {
    state.giftCard.redirectUrl = RedirectUrl;
    state.giftCard.order = Order;
  }
};
